module.exports = __webpack_public_path__ + "static/berkley-ae0503ca855667de8cd4819f98188bab.png";